import React from 'react'
import { styled, CSS } from '@grupoboticario/flora'
import {
  ModalBody,
  ModalBodyProps,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  ModalHeaderProps,
} from '@grupoboticario/flora-react-modal'
import { FloraTextarea } from '@grupoboticario/flora-react-textarea'
import { Heading, HeadingProps } from '@grupoboticario/flora-react-heading'
import { FloraButton } from '@grupoboticario/flora-react-button'

export const Content = styled((props: ModalContentProps) => <ModalContent {...props} />, {
  width: '100%',
  borderRadius: '$medium $medium 0 0',
  boxShadow: '0px 0px 16px 0px #0000003D',
  padding: '$2 0',

  '@tablet': {
    borderRadius: '$medium',
  },
})

export const Header = styled((props: ModalHeaderProps) => <ModalHeader {...props} />, {
  paddingBottom: '$2',
})

export const Body = styled((props: ModalBodyProps) => <ModalBody {...props} />, {
  paddingTop: '$2',
})

export const scoreButtonsContainer: CSS = {
  justifyContent: 'start',

  '@mobile': {
    justifyContent: 'center',
  },
}

export const ScoreButton = styled('button', {
  width: '86px',
  background: 'none',
  border: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  lineHeight: '16px',
  cursor: 'pointer',
  padding: 0,

  '& + button': {
    marginLeft: '$2',
  },
})

export const Comment = styled(FloraTextarea, {
  resize: 'none',
  marginTop: '$4',
})

export const Title = styled((props: HeadingProps) => <Heading {...props} />, {
  display: 'flex',
  alignItems: 'center',
  paddingRight: '$10',

  svg: {
    marginRight: '$2',
  },

  variants: {
    bold: {
      true: {
        fontWeight: '$strong',
      },
    },
  },
})

export const SubmitButton = styled(FloraButton, {
  width: '100%',
  marginTop: '$6',
})

export const CheckCircleFillIcon = styled('span', {
  width: '$12',
  height: '$12',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#F5F1EB',
  borderRadius: '$pill',
})
